


export default function Entries() {
    return(
        <div>
            
        </div>
    )
}